// Shared reservation-band visual rules for the calendar pages (single-apartment grid +
// multi-apartment timeline). Keeping these in one place is what guarantees a stay looks the
// same regardless of which view it's rendered in.

export const CHECKIN_OFFSET = 0.30;  // shape starts 30% into check-in cell (noon arrival)
export const CHECKOUT_OFFSET = 0.20; // shape ends 20% into check-out cell (morning departure)

export interface ReservationColors {
  bg: string;
  border: string;
  text: string;
}

export const PAST_RESERVATION_COLORS: ReservationColors = { bg: '#f1f5f9', border: '#cbd5e1', text: '#94a3b8' };

export function platformColors(platform: string | null): ReservationColors {
  const p = (platform ?? '').toLowerCase();
  if (p.includes('airbnb')) return { bg: '#fdeae7', border: '#eca898', text: '#7f1d1d' };
  if (p.includes('booking')) return { bg: '#dbeafe', border: '#93c5fd', text: '#1e3a8a' };
  if (p.includes('vrbo') || p.includes('homeaway')) return { bg: '#fef3c7', border: '#fcd34d', text: '#78350f' };
  if (!platform) return { bg: '#dcfce7', border: '#86efac', text: '#14532d' };
  return { bg: '#ede9fe', border: '#c4b5fd', text: '#4c1d95' };
}
